import JsPDF from "jspdf";
import { imageUrlToBase64 } from "./common";
import { convertArabic } from "arabic-reshaper";
import bidiFactory from "bidi-js"; // or "bidi-js/lib/index.js" if ESM fails
import "./fonts/Traditional-arabic-bold";
import "./fonts/NotoNaskhArabic-Bold-normal";
import "./fonts/PT Bold Heading Regular-normal";

const decisionApadterIfWin = {
  1: " إلى السنة الثّانية ",
  2: " إلى السنة الثّالثة ",
  3: " إلى السنة الرابعة ",
  4: " إلى السنة الخامسة ",
  5: " إلى السنة السادسة ",
  6: " إلى السنة السابعة ",
};
const bidi = bidiFactory();

function arabicPreprocess(text, explicitDirection = "rtl") {
  if (!text || typeof text != "string") return text;
  else {
    const reshaped = convertArabic(text);
    const embeddingLevels = bidi.getEmbeddingLevels(text);
    return bidi
      .getReorderedString(reshaped, embeddingLevels)
      .split("")
      .reverse()
      .join("");
  }
}

async function drawBulletin(bulletin, details, templateID, doc = null) {
  if (!doc) doc = new JsPDF();
  const pdf_width = doc.internal.pageSize.width;
  const pdf_height = doc.internal.pageSize.height;
  let text = "";
  let text2 = "";
  let width = 0;
  let width2 = 0;
  const startY = templateID == "CP" ? 20 : 10;
  let currentY = startY;
  const yHeaderStep = 6;

  // add border if AC
  // if (templateID == "AC") {
  //   const imageUrl = "/resources/images/templatesBulletin/simple_border.png";

  //   //Add the image as a background
  //   doc.addImage(imageUrl, "JPEG", 0, 0, pdf_width, pdf_height);
  // }

  doc.setFont("Amiri", "Bold");
  doc.setFontSize(10);
  // calculating the length of the longest header
  text = "المندوبيّة الجهويّة للتربيّة";
  text += details.delegeRegional
    ? " بـ " + details.delegeRegional
    : "..................بـ ";
  text = text || " ";
  const r_width = doc.getTextWidth(text);
  const r_startX = pdf_width - r_width - 2;
  const refX = r_startX + r_width / 2;
  let startX = 2;

  // gov
  text = "الجمهورية التونسية";
  text = text || " ";
  width = doc.getTextWidth(text);
  startX = refX - width / 2;
  doc.text(text, startX, currentY);
  currentY += yHeaderStep;

  // minester
  text = "وزارة التربية";
  text = text || " ";
  width = doc.getTextWidth(text);
  startX = refX - width / 2;
  doc.text(text, startX, currentY);
  currentY += yHeaderStep;

  // regional
  text = "المندوبيّة الجهويّة للتربيّة";
  text += details.delegeRegional
    ? " بـ" + details.delegeRegional
    : "..................بـ ";
  text = text || " ";
  width = doc.getTextWidth(text);
  startX = refX - width / 2;
  doc.text(arabicPreprocess(text), r_startX, currentY);
  let logoEndY = currentY;
  currentY += yHeaderStep;

  if (templateID == "AC") {
    logoEndY = currentY;
    // school type
    text = "المدرسة الابتدائيّة الخاصة ";
    text = text || " ";
    width = doc.getTextWidth(text);
    startX = refX - width / 2;
    doc.text(arabicPreprocess(text), startX, currentY);
    currentY += yHeaderStep;

    // school name
    text = details.schoolName || "..............";
    text = text || " ";
    width = doc.getTextWidth(text);
    startX = refX - width / 2;
    doc.text(arabicPreprocess(text), startX, currentY);
  } else {
    text = details.schoolName
      ? details.schoolName + arabicPreprocess("المدرسة الابتدائيّة الخاصة ")
      : arabicPreprocess(
          "........................ :المدرسة الابتدائيّة الخاصة"
        );
    text = text || " ";
    width = doc.getTextWidth(text);
    startX = pdf_width - width - 1;
    doc.text(text, startX, currentY);
  }

  // schoolar year
  const schoolarYearY = currentY;
  text = ` ${details.schoolarYear}  : السنة الدراسيّة`;
  text = text || " ";
  width = doc.getTextWidth(text);
  doc.text(text, 10, schoolarYearY);
  currentY += 8;

  // school logo
  if (details.logo) {
    const logoStartY = templateID == "CP" ? 0 : startY;
    try {
      doc.addImage(
        details.logo,
        "JPEG",
        10,
        logoStartY,
        width,
        logoEndY - logoStartY
      );
    } catch (error) {
      console.info("could not add logo: \n", error);
    }
  }

  currentY += 10;

  // big title
  doc.setFont("NotoNaskhArabic-Bold", "normal");
  text = arabicPreprocess(
    templateID == "CP" ? "النّتائج المدرسيّة" : "النّتائج النهائيّة"
  );
  if (templateID == "CP") doc.setTextColor(68, 7, 186);
  doc.setFontSize(32);
  text = text || " ";
  width = doc.getTextWidth(text);
  doc.text(text, pdf_width / 2, currentY, { align: "center" });
  currentY += 10;

  // student line

  // student name
  let studentLabel = bulletin.gender === "male" ? " : التلميذ" : " : التلميذة";
  doc.setFont("Amiri", "normal");
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);
  text = studentLabel;
  text = text || " ";
  width = doc.getTextWidth(text);
  doc.text(text, pdf_width - width - 12, currentY);
  text = bulletin.fullName;
  doc.setFont("Amiri", "Bold");
  doc.setFontSize(13);
  text = text || " ";
  width2 = doc.getTextWidth(text);
  doc.text(text, pdf_width - width - width2 - 12, currentY);
  doc.setFont("Amiri", "normal");
  doc.setFontSize(12);

  // student classroom
  text = " : القسم";
  text = text || " ";
  width = doc.getTextWidth(text);
  doc.text(text, pdf_width / 2, currentY);
  text = bulletin.classroomName;
  text = text || " ";
  width2 = doc.getTextWidth(text);
  doc.text(text, pdf_width / 2 - width2, currentY);

  // Number of inscribers in classroom
  text = String(bulletin.nbInscriped);
  doc.text(text, 10, currentY);
  text = text || " ";
  width = doc.getTextWidth(text);
  text = " :عدد التلاميذ المرسّمين";
  doc.text(text, width + 10, currentY);

  // marks zones
  const trimMoyText = { x: pdf_width - 45 - 12, w: 45, h: 10 };
  const trimMoyValue = { x: pdf_width - 45 - 15 - 12, w: 15, h: 10 };
  let trimMoyY = currentY + 20;
  const finalMoyTextY = trimMoyY;
  doc.setLineWidth(0.3);
  doc.setFont("Amiri", "Bold");
  doc.setFontSize(13);
  const baseTrimTextt = "معدّل الثّلاثي";
  const trimNumber = ["الأوّل", "الثّاني", "الثّالث"];
  const trimMoys = [
    bulletin.moyenneOne,
    bulletin.moyenneTwo,
    bulletin.moyenneThree,
  ];
  for (let trim of [0, 1, 2]) {
    text = baseTrimTextt + " " + trimNumber[trim];
    text2 = trimMoys[trim];
    doc.setFontSize(15);
    text = arabicPreprocess(text || " ");
    width = doc.getTextWidth(text);
    doc.setFontSize(12);
    text2 = text2 || " ";
    width2 = doc.getTextWidth(text2);

    // trim moy text rectangle
    doc.rect(trimMoyText.x, trimMoyY, trimMoyText.w, trimMoyText.h);
    doc.setFillColor(204, 229, 255);
    doc.rect(trimMoyText.x, trimMoyY, trimMoyText.w, trimMoyText.h, "FD");
    doc.setFontSize(15);
    const trimMoyTextX = trimMoyText.x + trimMoyText.w - 5 - width;
    const trimMoyTextY = trimMoyY + trimMoyText.h * 0.6;
    doc.text(text, trimMoyTextX, trimMoyTextY);

    // trim moy value rectangge
    doc.rect(trimMoyValue.x, trimMoyY, trimMoyValue.w, trimMoyValue.h);
    doc.setFontSize(12);
    const trimMoyValueX = trimMoyValue.x + trimMoyValue.w - width2 - 2;
    const trimMoyValueY = trimMoyY + trimMoyValue.h * 0.6;
    doc.text(text2, trimMoyValueX, trimMoyValueY);

    trimMoyY += trimMoyText.h + 1;
  }

  // final Moy zone
  const finalMoyDims = {
    w: 30,
    h: 10,
  };
  let finalMoyX = 10;
  const finalyYValue = finalMoyTextY + finalMoyDims.h;
  const finalMoyTexts = [
    "أدنى معدّل سنوي بالقسم",
    "أعلى معدّل سنوي بالقسم",
    "المعدّل السّنوي",
  ];
  const finalMoyValues = [
    bulletin.minFinalMoyenne,
    bulletin.maxFinalMoyenne,
    bulletin.finalMoyenne,
  ];
  doc.setFontSize(9);
  for (let i of [0, 1, 2]) {
    // final moy text
    doc.rect(finalMoyX, finalMoyTextY, finalMoyDims.w, finalMoyDims.h);
    doc.setFillColor(204, 229, 255);
    doc.rect(finalMoyX, finalMoyTextY, finalMoyDims.w, finalMoyDims.h, "FD");
    if (i == 2) doc.setFontSize(14);
    doc.text(
      arabicPreprocess(finalMoyTexts[i]),
      finalMoyX + 1 + (i == 2 ? 3 : 0),
      finalMoyTextY + finalMoyDims.h * 0.6
    );
    if (i == 2) doc.setFontSize(14);

    // final moy value
    doc.rect(finalMoyX, finalyYValue, finalMoyDims.w, finalMoyDims.h);
    if (templateID === "AC") {
      doc.setFillColor(255, 255, 255);
    } else {
      doc.setFillColor(178, 178, 178);
    }
    doc.rect(finalMoyX, finalyYValue, finalMoyDims.w, finalMoyDims.h, "FD");
    if (i == 2) doc.setFontSize(14);
    else doc.setFontSize(12);
    doc.text(
      finalMoyValues[i],
      finalMoyX + 10,
      finalyYValue + finalMoyDims.h * 0.6
    );
    doc.setFontSize(9);

    finalMoyX += finalMoyDims.w + 10;
  }

  // decision text Box
  let w = 80;
  const decisionBoxDims = {
    y: trimMoyY + 10,
    x: pdf_width / 2 - w / 2,
    h: 25,
    w,
  };

  doc.rect(
    decisionBoxDims.x,
    decisionBoxDims.y,
    decisionBoxDims.w,
    decisionBoxDims.h
  );
  doc.setFillColor(204, 229, 255);
  doc.rect(
    decisionBoxDims.x + 2,
    decisionBoxDims.y + 2,
    decisionBoxDims.w - 4,
    decisionBoxDims.h - 4,
    "F"
  );
  doc.setFont("Traditional Arabic", "Bold");
  doc.setFontSize(36);
  doc.setTextColor(38, 53, 103);
  text = "قرار مجلس القسم";
  text = text || " ";
  width = doc.getTextWidth(text);
  doc.text(
    text,
    pdf_width / 2 - width / 2,
    decisionBoxDims.y + decisionBoxDims.h * 0.6
  );

  // decision value box
  w = 120;
  const decisionValueBoxDims = {
    y: decisionBoxDims.y + decisionBoxDims.h,
    x: pdf_width / 2 - w / 2,
    h: 25,
    w,
  };

  doc.rect(
    decisionValueBoxDims.x,
    decisionValueBoxDims.y,
    decisionValueBoxDims.w,
    decisionValueBoxDims.h
  );

  doc.setFontSize(32);
  doc.setTextColor(255, 0, 0);
  text = "";
  if (bulletin.finalMoyenne > 8.99) {
    text = bulletin.decisionConseil + decisionApadterIfWin[details.level] || "";
  } else text = bulletin.decisionConseil;
  text = arabicPreprocess(text || " ");
  width = doc.getTextWidth(text);
  doc.setFont("NotoNaskhArabic-Bold", "normal");
  doc.text(
    text,
    pdf_width / 2 - width / 2 - 10,
    decisionValueBoxDims.y + decisionValueBoxDims.h * 0.6
  );

  // signatures box
  w = 70;
  const sigBoxDims = {
    y: decisionValueBoxDims.y + decisionValueBoxDims.h + 10,
    h: 50,
    w,
  };
  // left box
  doc.rect(pdf_width / 2, sigBoxDims.y, sigBoxDims.w, sigBoxDims.h);
  doc.setFont("Amiri", "Bold");
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(18);
  text = "(المدير)ة";
  text = text || " ";
  width = doc.getTextWidth(text);
  doc.text(text, pdf_width / 2 + 10, sigBoxDims.y + 10);
  doc.setFontSize(14);
  text2 = "الإمضاء";
  doc.text(text2, pdf_width / 2 + 10 + width, sigBoxDims.y + 20);
  // right box
  doc.rect(pdf_width / 2 - w, sigBoxDims.y, sigBoxDims.w, sigBoxDims.h);
  doc.setFont("Amiri", "normal");
  text = ` ...................... ${details.delegeRegional} في   `;
  text = text || " ";
  width = doc.getTextWidth(text);
  doc.text(text, pdf_width / 2 - width, sigBoxDims.y + 10);
  text = "ختم المؤسّسة";
  width2 = doc.getTextWidth(text);
  doc.text(text, pdf_width / 2 - width2 - 5, sigBoxDims.y + 20);
  // stamp
  const stampW = 30;
  const stampH = 30;
  const stampX = pdf_width / 2 - width2 - 5 - stampW;
  const stampY = sigBoxDims.y + 20;
  try {
    if (details.stamp != null)
      doc.addImage(details.stamp, "JPEG", stampX, stampY, stampW, stampH);
  } catch (error) {
    console.info("could not add stamp: \n", error);
  }

  return doc;
}

async function printBulletin(params) {
  const { bulletin, details, templateID, preview } = params;
  details.logo = details.logo ? await imageUrlToBase64(details.logo) : null;
  details.stamp = details.stamp ? await imageUrlToBase64(details.stamp) : null;
  const bulletinPDF = await drawBulletin(bulletin, details, templateID);
  if (preview) return bulletinPDF.output("bloburl");
  bulletinPDF.save(`Bulletins Annuel ${bulletin.fullName || " "}.pdf`);
}
async function printAllBulletin(params) {
  const { bulletins, details, templateID } = params;
  details.logo = details.logo ? await imageUrlToBase64(details.logo) : null;
  details.stamp = details.stamp ? await imageUrlToBase64(details.stamp) : null;
  let bulletinPDF;
  let i = 0;
  const l = bulletins.length;
  for (let bulletin of bulletins) {
    bulletinPDF = await drawBulletin(
      bulletin,
      details,
      templateID,
      bulletinPDF
    );
    i++;
    if (i < l) bulletinPDF.addPage();
  }
  //return bulletinPDF.output("bloburl");
  bulletinPDF.save(`Bulletins Annuel ${details.className || " "}.pdf`);
}

export default {
  printBulletin,
  printAllBulletin,
};
